import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { join } from 'path';
import { Pedido } from 'src/app/models/pedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoCampoPersonalizadoSelecionadoService } from 'src/app/services/pedido-campo-personalizado-selecionado.service';
import { PedidoCampoPersonalizadoService } from 'src/app/services/pedido-campo-personalizado.service';
import { forkJoin } from 'rxjs';
import swal from 'sweetalert2';

@Component({
  selector: 'app-filtro-classificacao-pedidos',
  templateUrl: './filtro-classificacao-pedidos.component.html',
  styleUrls: ['./filtro-classificacao-pedidos.component.scss']
})
export class FiltroClassificacaoPedidosComponent implements OnInit {

  tabelas = [];
  editavel = true;
  classificacaoSelecionada;
  idsCupom: string = "";
  pedidosSelecionados: Pedido[] = [];
  acao: boolean = false;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<FiltroClassificacaoPedidosComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private pedidoCampoPersonalizadoService: PedidoCampoPersonalizadoService,
    private pedidoCampoPersonalizadoSelecionadoService: PedidoCampoPersonalizadoSelecionadoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.tabelas = this.data.tabelas;
    this.acao = this.data.acao;
    this.pedidosSelecionados = this.data.pedidosSelecionado;
  }

  ngOnInit(): void {
    if (this.tabelas.length === 0)
      this.buscarClassificacaoPersonalizada();
  }

  buscarClassificacaoPersonalizada() {
    this.carregandoService.mostra('buscaClassificacao');
    this.pedidoCampoPersonalizadoService.consultarTodosPedidoCampoPersonalizado().subscribe(r => {
      this.tabelas = r;
      this.carregandoService.esconde('buscaClassificacao');
    }, (erro) => {
      this.carregandoService.esconde('buscaClassificacao');
      this.notificacaoService.erro('Não foi possível carregar os campos personalizados');
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  async pesquisar() {
    if (this.acao) {
      swal({
        title: 'Atenção!!',
        html: 'Esta classificação irá sobrepor a classificação dos pedidos selecionados. Deseja continuar?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          const pedidosIds = this.pedidosSelecionados.map(ps => ps.idCupom);
      
          this.carregandoService.mostra('salvaFilterPerson');
          
          forkJoin(
            pedidosIds.map(id => this.pedidoCampoPersonalizadoSelecionadoService.salvar(this.tabelas, id))
          ).subscribe( 
            () => {
              this.carregandoService.esconde('salvaFilterPerson');
              this.notificacaoService.sucesso('Classificação atribuída com sucesso');
              this.dialogRef.close(false);
            },
            (erro) => {
              console.error(erro);
              this.carregandoService.esconde('salvaFilterPerson');
            }
          );
        }
      });      
    } else 
      this.dialogRef.close(this.tabelas);    
  }
}
